import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import type { ApiResponse } from "@membentry/shared-types";

import type { ClubVariables, MutationOptions } from "./types";

type QueryClient = ReturnType<typeof useQueryClient>;

export function usePtMutation<T, Variables extends ClubVariables>(
  client: AxiosInstance,
  options: MutationOptions<T, Variables> | undefined,
  mutationFn: (
    client: AxiosInstance,
    variables: Variables,
  ) => Promise<ApiResponse<T>>,
  invalidate: (queryClient: QueryClient, clubId: number) => void,
) {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: (variables) => mutationFn(client, variables),
    onSuccess: async (data, variables, onMutateResult, context) => {
      invalidate(queryClient, variables.clubId);
      await options?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
}
